export const SHOW = "snackbar/SHOW";
export const HIDE = "snackbar/HIDE";

export const showSnackbar = message => ({
  type: SHOW,
  message
});

export const hideSnackbar = () => ({
  type: HIDE
});

const initialState = {
  open: false,
  message: ""
};

const snackbar = (state = initialState, action) => {
  switch (action.type) {
    case SHOW:
      return {
        open: true,
        message: action.message
      };
    case HIDE:
      return { ...state, open: false };
    default:
      return state;
  }
};

export default snackbar;



// WEBPACK FOOTER //
// ./src/redux/modules/snackbar.js